import { useState, useEffect } from "react";
import { useApi } from "../../utils/api/useApi";
import { usStatesEndpoint } from "../../utils/api/urls";
import { StateDto } from "../../models/stateDto";
import { useTranslation } from "../useTranslationHook/useTranslation";

export const useUsStates = () => {
  const [states, setStates] = useState<StateDto[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const { get } = useApi<StateDto[]>();
  const { translateId, locale } = useTranslation();

  useEffect(() => {
    const fetchStates = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await get(usStatesEndpoint);

        const translatedData = data.map((state) => {
          const code = state.twoLetterCode.code?.toUpperCase() ?? "";
          const id = `USSTATE.${code}`;
          return {
            ...state,
            name: translateId(id)
          };
        });

        setStates(translatedData);
      } catch (err: any) {
        setError(err.message || "Error fetching US states.");
      } finally {
        setLoading(false);
      }
    };

    fetchStates();
  }, [get, translateId, locale]);

  return { states, loading, error };
};
